import { ca } from '@cian/analytics';

const baseEvent = {
  name: 'oldevent',
  category: 'Listing',
};

export function trackAdvancedModalOpenEvent() {
  ca('event', {
    ...baseEvent,
    action: 'popup_more_param_open',
  });
}
